module.exports = __webpack_public_path__ + "static/media/battery@2x.207176be.png";